
  <header role="banner" *ngIf="tenantService.isCXOne===false" [attr.aria-label]="'banner.landmark.label' | translate">
  <nav class="top-bar navbar navbar-expand navbar-light fixed-top" [ngClass]="showMainLayoutCssObj">
    <span class="app-name">Enhanced Strategic Planner</span>
    <div class="navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown dropdown-user" ngbDropdown placement="bottom-end" #myDrop="ngbDropdown">
          <button type="button" class="nav-link dropdown-toggle" id="navbarDropdown" tabindex="0" ngbDropdownToggle>
            <span>{{username}}</span>
          </button>
          <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="navbarDropdown">
            <button *ngIf="showApiCredentialsMenuItem()"
               type="button"
               id="apiCredsLink"
               ngbDropdownItem
               [disabled]="!isPublicApiFeatureEnabled()"
               (click)="showApiCredentialsDialog()"
               title="{{'api.credentials.dropdown.item' | translate}}">
              {{"api.credentials.dropdown.item" | translate}}
            </button>
            <button type="button" id="logoutLink" ngbDropdownItem (click)="logout()">
              {{"logout" | translate}}
            </button>
          </div>
        </li>
      </ul>
      <div class = "help-icon">
          <button id="helpLink" type="button" class="btn-icon"
            [attr.aria-label]="'esp.help.aria.label' | translate"
            title="{{'esp.help' | translate}}"
            (click)="gotoHelp()">
            <esp-icon name="help" [size]="20"></esp-icon>
          </button>
      </div>
      <div class="navbar-brand">
          <img src="/assets/images/nice-logo-black-with-white.svg" height="24" alt="NICE Ltd">
      </div>
    </div>
  </nav>
  </header>
  <div class="d-flex flex-column flex-nowrap content-wrapper app-wrapper"
       [ngClass]="{'with-top-bar': showMainLayout && !this.tenantService.isCXOne,'show-mini-sidebar':!isMenuExpanded,'esp-embedded': tenantService.isCXOne}">
    <div class="app-content d-flex flex-row flex-nowrap flex-grow-1 flex-shrink-1" style="flex-basis: 100%">
      <app-side-nav *ngIf="tenantService.isCXOne===false"
                    [ngClass]="showMainLayoutCssObj"
                    [tabIndex]="0"
                    [inputMenuItems]="menu"
                    [isMenuExpanded]="isMenuExpanded"
                    (SidebarToggle)="onSidebarToggle()">
      </app-side-nav>
      <div class="main-content flex-grow-1 flex-shrink-1 d-flex flex-column flex-nowrap" style="flex-basis: 100%"
           role="main" [attr.aria-label]="'main.landmark.label' | translate"
           [ngClass]="{'container-fluid': showMainLayout}">
        <p *ngIf="isError" class="message-unstyled connection-error">
          <esp-icon class="connection-error-icon" name="circle-alert"></esp-icon>
          There was a problem connecting to Enhanced Strategic Planner.
        </p>
        <div class="content-area flex-shrink-1 flex-grow-1" style="flex-basis: 100%; position: relative; overflow-y: auto; overflow-x: hidden">
            <router-outlet></router-outlet>

        </div>
      </div>
    </div>
  </div>
<p-toast position="bottom-right" class="p-toast-esp-root">

</p-toast>
